<div class="fingerprint-input">
    <fa-icon class="status" [icon]="hasValue ? 'check' : 'xmark'"
        [style]="{'color': hasValue ? 'green' : 'red'}"></fa-icon>
    <button type="button" class="toggle-preview cursor-pointer" *ngIf="hasValue" (click)="$event.stopPropagation(); toggleDisplayPreview()">
        {{displayPreview ? '&#x2212;' : '+'}}
    </button>
    <app-big-button class="big_btn big_btn-resp fullWidth"
        [icon]="icon"
        [label]="labelKey | translate"
        [description]="description?.length ? (description | translate) : undefined"
        [selected]="hasValue"
        [responsive]="true"
        (clicked)="openFingerprintModal()">
    </app-big-button>
    <div class="preview-box" *ngIf="hasValue">
        <table class="preview" *ngIf="displayPreview">
            <thead>
                <tr>
                    <th></th>
                    <th>{{'finger.thumb' | translate}}</th>
                    <th>{{'finger.index' | translate}}</th>
                    <th>{{'finger.middle' | translate}}</th>
                    <th>{{'finger.ring' | translate}}</th>
                    <th>{{'finger.little' | translate}}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <th>{{'hand.left' | translate}}</th>
                    <td [style]="{
                        'color': value.Thumbs.Left.nfiq === 0 ? 'gray' : value.Thumbs.Left.nfiq < 3 ? 'green': 'red'
                    }">
                        <img [src]="value.Thumbs.Left.previewData" [style]="{
                            'display': value.Thumbs.Left.previewData !== undefined ? 'block': 'none'
                        }" />
                         <div>{{renderNfiq(value.Thumbs.Left.nfiq)}}</div>
                    </td>
                    <td [style]="{
                        'color': value.LeftHand.Index.nfiq === 0 ? 'gray' : value.LeftHand.Index.nfiq < 3 ? 'green': 'red'
                    }">
                        <img [src]="value.LeftHand.Index.previewData" [style]="{
                            'display': value.LeftHand.Index.previewData !== undefined ? 'block': 'none'
                        }" />
                        <div>{{renderNfiq(value.LeftHand.Index.nfiq)}}</div>
                    </td>
                    <td [style]="{
                        'color': value.LeftHand.Middle.nfiq === 0 ? 'gray' : value.LeftHand.Middle.nfiq < 3 ? 'green': 'red'
                    }">
                        <img [src]="value.LeftHand.Middle.previewData" [style]="{
                            'display': value.LeftHand.Middle.previewData !== undefined ? 'block': 'none'
                        }" />
                        <div>{{renderNfiq(value.LeftHand.Middle.nfiq)}}</div>
                    </td>
                    <td [style]="{
                        'color': value.LeftHand.Ring.nfiq === 0 ? 'gray' : value.LeftHand.Ring.nfiq < 3 ? 'green': 'red'
                    }">
                        <img [src]="value.LeftHand.Ring.previewData" [style]="{
                            'display': value.LeftHand.Ring.previewData !== undefined ? 'block': 'none'
                        }" />
                        <div>{{renderNfiq(value.LeftHand.Ring.nfiq)}}</div>
                    </td>
                    <td [style]="{
                        'color': value.LeftHand.Little.nfiq === 0 ? 'gray' : value.LeftHand.Little.nfiq < 3 ? 'green': 'red'
                    }">
                        <img [src]="value.LeftHand.Little.previewData" [style]="{
                            'display': value.LeftHand.Little.previewData !== undefined ? 'block': 'none'
                        }" />
                        <div>{{renderNfiq(value.LeftHand.Little.nfiq)}}</div>
                    </td>
                </tr>
                <tr>
                    <th>{{'hand.right' | translate}}</th>
                    <td [style]="{
                        'color': value.Thumbs.Right.nfiq === 0 ? 'gray' : value.Thumbs.Right.nfiq < 3 ? 'green': 'red'
                    }">
                        <img [src]="value.Thumbs.Right.previewData" [style]="{
                            'display': value.Thumbs.Right.previewData !== undefined ? 'block': 'none'
                        }" />
                        <div>{{renderNfiq(value.Thumbs.Right.nfiq)}}</div>
                    </td>
                    <td [style]="{
                        'color': value.RightHand.Index.nfiq === 0 ? 'gray' : value.RightHand.Index.nfiq < 3 ? 'green': 'red'
                    }">
                        <img [src]="value.RightHand.Index.previewData" [style]="{
                            'display': value.RightHand.Index.previewData !== undefined ? 'block': 'none'
                        }" />
                        <div>{{renderNfiq(value.RightHand.Index.nfiq)}}</div>
                    </td>
                    <td [style]="{
                        'color': value.RightHand.Middle.nfiq === 0 ? 'gray' : value.RightHand.Middle.nfiq < 3 ? 'green': 'red'
                    }">
                        <img [src]="value.RightHand.Middle.previewData" [style]="{
                            'display': value.RightHand.Middle.previewData !== undefined ? 'block': 'none'
                        }" />
                        <div>{{renderNfiq(value.RightHand.Middle.nfiq)}}</div>
                    </td>
                    <td [style]="{
                        'color': value.RightHand.Ring.nfiq === 0 ? 'gray' : value.RightHand.Ring.nfiq < 3 ? 'green': 'red'
                    }">
                        <img [src]="value.RightHand.Ring.previewData" [style]="{
                            'display': value.RightHand.Ring.previewData !== undefined ? 'block': 'none'
                        }" />
                        <div>{{renderNfiq(value.RightHand.Ring.nfiq)}}</div>
                    </td>
                    <td [style]="{
                        'color': value.RightHand.Little.nfiq === 0 ? 'gray' : value.RightHand.Little.nfiq < 3 ? 'green': 'red'
                    }">
                        <img [src]="value.RightHand.Little.previewData" [style]="{
                            'display': value.RightHand.Little.previewData !== undefined ? 'block': 'none'
                        }" />
                        <div>{{renderNfiq(value.RightHand.Little.nfiq)}}</div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>